import React from 'react';

/**
 * Renders the amp markup for the component. We DO not use the arrow style so that we can have access to this.
 */
function renderAmp() {
  const {
    id, name, options, selectedOption, placeholder, isDisabled,
  } = this.props; // eslint-disable-line

  return (
    <amp-selector
      id={id}
      name={name}
      options={options}
      selected={selectedOption}
      placeholder={placeholder}
      disabled={isDisabled}
      keyboard-select-mode="select"
      layout="container"
    />
  );
}

export default renderAmp;
